const scope = process.env.VUE_APP_SESSION_SCOPE || 'online-v1'
const tokenKey = `cloudphone:h5:${scope}:token`
const userKey = `cloudphone:h5:${scope}:user`

// Use a separate namespace so old local-test credentials cannot reach live APIs.
export function getToken() {
  return localStorage.getItem(tokenKey)
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(userKey)) || {}
  } catch {
    return {}
  }
}

export function saveSession(result) {
  if (!result?.token || !result?.user) {
    throw new Error('登录信息不完整，请重新登录')
  }
  localStorage.setItem(userKey, JSON.stringify(result.user))
  localStorage.setItem(tokenKey, result.token)
}

export function updateSessionUser(user) {
  if (!user) return
  localStorage.setItem(userKey, JSON.stringify(user))
}

export function clearSession() {
  localStorage.removeItem(tokenKey)
  localStorage.removeItem(userKey)
}
